const whatsNewAnnouncements = [
    {
        id: 'product-themes',
        isActive: false,
        title: "What's New",
        eyebrow: 'New feature',
        featureTitle: 'Fresh themes are now available',
        description:
            'Explore the new product themes to preview updated styling options and launch a cleaner storefront experience faster.',
        ctaLabel: 'Try it now',
        ctaPath: '/admin/products',
        fallbackCtaPath: '/admin/products',
        ctaPathResolverEndpoint: '/announcements/most-used-form',
        imageAlt: 'Preview of the new themes feature',
        imagePlaceholderLabel: 'Feature screenshot',
        previewPresets: [
            {
                value: 'terracotta-slate',
                label: 'Terracotta & Slate',
                description: 'Warm and stable palette that feels human, approachable, and polished.',
                cta_color: '#E07A5F',
                highlight_color: '#F4F1DE',
                accent_color: '#3D405B',
                button_text_color: '#FFFFFF'
            },
            {
                value: 'sand-teal',
                label: 'Sand & Deep Teal',
                description: 'Premium organic palette that feels clean, calm, and trustworthy.',
                cta_color: '#006D77',
                highlight_color: '#EDF6F9',
                accent_color: '#006D77',
                button_text_color: '#FFFFFF'
            }
        ]
    }
]

export default whatsNewAnnouncements
